// extracted by mini-css-extract-plugin
export default {"container":"Pill_container__ZFIxV","selected":"Pill_selected__ppEj8"};